<script setup>
const props = defineProps({
  modelValue: Boolean,
  parentAnnotation: { type: Object, default: null },
})

const emit = defineEmits(['update:modelValue', 'onSubmit', 'onClose'])

const comment = ref('')

const closeDialog = () => {
  emit('update:modelValue', !props.modelValue)
}

const onClose = async () => {
  comment.value = ''
  emit('onClose')
}
</script>

<template>
  <VDialog
    :model-value="modelValue"
    max-width="600"
    class="default-dialog"
    @after-leave="onClose"
    @update:modelValue="emit('update:modelValue')"
  >
    <VBtn
      variant="elevated"
      density="compact"
      icon="tabler-x"
      class="v-dialog-close-btn"
      @click="closeDialog"
    />

    <VCard title="Comment Annotation">
      <VCardText>
        <VRow
          v-if="parentAnnotation"
        >
          <VCol>
            <h4>
              {{ parentAnnotation.username }} at {{ parentAnnotation.created_at }}:
            </h4>
            <p>{{ parentAnnotation.comment }}</p>
          </VCol>
        </VRow>
        <VRow>
          <VCol class="py-0">
            <VTextarea
              v-model="comment"
              label="Comment"
            />
          </VCol>
        </VRow>
        <VRow>
          <VCol
            class="d-flex justify-end"
            cols="12"
          >
            <VBtn
              variant="outlined"
              @click="$emit('onSubmit', comment)"
            >
              Save
            </VBtn>
          </VCol>
        </VRow>
      </VCardText>
    </VCard>
  </VDialog>
</template>
